import { render, staticRenderFns } from "./formAction.vue?vue&type=template&id=09f29ddc&scoped=true&"
import script from "./formAction.vue?vue&type=script&lang=babel&"
export * from "./formAction.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f29ddc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
installComponents(component, {VBottomNavigation})
